import { useQuery } from "@tanstack/react-query";
import { clubApi } from "../../../club-api-client";
import { queryKeys } from "../../query-keys";

export function useMemberAudit(
	clubId: string | null,
	memberId: string,
	params: { limit?: number; offset?: number } = {},
) {
	return useQuery({
		queryKey: queryKeys.clubPortal.memberAudit(clubId ?? "", memberId, params),
		queryFn: () => clubApi.memberAudit.list(clubId!, memberId, params),
		enabled: !!clubId && !!memberId,
	});
}
